<style scoped>
.svgContent {
  width: 100%;
  text-align: center;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);

  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);

  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;

  -webkit-perspective: 1000;
  perspective: 1000;

  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
.svgTitle {
  position: fixed;
  width: 100%;
  top: 5px;
  z-index: 999;
  text-align: center;
}
.svgTitle h3 h4 {
  background-color: white;
}
.svgTitle-close {
  float: right;
  margin-top: 3px;
  margin-right: 3px;
}
.lineOpen {
  position: fixed;
  outline: 0;
  width: 95%;
  margin-left: 10px;
  top: 38px;
  color: white;
  background-color: rgba(0, 0, 0, 0.4);
  border: 0;
  border-radius: 6px;
  background-clip: padding-box;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 5px;
  z-index: 999;
}
.svgFooter {
  position: fixed;
  bottom: 0px;
  width: 100%;
}

.performance {
  position: fixed;
  bottom: 55px;
  right: 10px;
  z-index: 999;
}
.van-steps {
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0);
}
.van-step{
  font-size:12px;
}
.van-step--finish {
    color: #fff;
}
</style>
<style>
.van-picker__columns {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  cursor: grab;
  bottom: 15px;
}
</style>

<template>
  <div>
    <div class="svgTitle">
      <h3>{{ orderBean.advertiserName }}-{{ orderBean.brandName }}</h3>
    </div>
    <div class="performance" @click="showPerformanceModal">
      <h3>查看履约进程</h3>
    </div>

    <div class="lineOpen performance-Content" v-if="showPerformance">
      <label class="svgTitle-close" @click="showPerformance=false">
        <van-icon name="cross" />
      </label>
      <van-row>
        <van-col span="24">
         <van-steps  direction="vertical"  :active="performanceActive" finish-color="#fff" inactive-color='#fff' active-color="#ee7c4b">

          <van-step  v-for="(progress, index) in performance.taskProgressTypeList" :key="index">
            <h3>{{progress.taskProgressTypeName}}</h3>
            <p>{{progress.finishDate?'完成时间：'+progress.finishDate:'待执行'}}</p>
          </van-step>
        </van-steps>
        </van-col>
      </van-row>
    </div>

    <div v-if="playIndex > -1 && showPlayContent" class="lineOpen">
      <label class="svgTitle-close" @click="handleCloseTitle">
        <van-icon name="cross" />
      </label>
      <p class="text-center">
        {{ stationList[playIndex].stationName }} ({{
          stationList[playIndex].stationLevelName
        }}级)
      </p>
      <van-row>
        <van-col span="24" v-if="stationInfoData.stationFlow>-1">
          月客流：<span style="margin-left: 18px"
            >{{
              formatNumber(stationInfoData.stationFlow)
            }}
            人次</span
          >
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24">
          投放产品：
          <span
            v-for="(product, index) in stationInfoData.productQuantity"
            :key="product.productId"
          >
            {{ product.productName }} ({{ product.quantity }}
            {{ product.unitName }})
            <span v-if="index < stationInfoData.productQuantity.length - 1"
              >、</span
            >
          </span>
        </van-col>
      </van-row>
      <van-row
        class="text-center"
        v-if="
          stationInfoData.demandList && stationInfoData.demandList.length > 0
        "
      >
        <van-col span="24">
          <van-image
            @click="handleImgStations(0)"
            lazy-load
            width="300"
            height="180"
            fit="cover"
            :src="
              stationInfoData.demandList[0] +
              '?x-oss-process=image/resize,w_300'
            "
          />
        </van-col>
        <!-- <van-col span="8" v-for="(item,index) in stationInfoData.demandList.slice(0, 6)" :key="'demand'+index">
                <van-image @click="handleImgStations(index)" lazy-load width="100" height="70" fit="cover" :src="item+'?x-oss-process=image/resize,h_70'" />
              </van-col> -->
      </van-row>
    </div>

    <div v-html="svgHtml" id="svgWorkPlatform" class="svgContent"></div>

    <van-row class="svgFooter">
      <van-col span="8">
        <van-button
          size="large"
          :icon="beginPlay ? 'pause' : 'play'"
          type="default"
          @click="handlePlayOrPause"
        >
          <span v-if="beginPlay">暂停历程</span>
          <span v-else>开始播放</span>
        </van-button>
      </van-col>
      <van-col span="16">
        <van-button
          size="large"
          type="default"
          icon="todo-list-o"
          @click="showSchedules = true"
        >
          {{ chooseSchedule.startDate }} - {{ chooseSchedule.endDate }}
        </van-button>
      </van-col>
    </van-row>

    <van-popup
      v-model="showSchedules"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        title="请选择投放档期"
        show-toolbar
        :default-index="defalutChooseSchedule"
        :columns="scheduleColumns"
        @confirm="handleChooseSchedule"
        @cancel="showSchedules = false"
      />
    </van-popup>
  </div>
</template>

<script>
import '@vant/touch-emulator' // 用于解决web端模拟移动端的触摸事件

import {
  Button,
  Col,
  Row,
  Popup,
  Picker,
  Cell,
  Toast,
  Icon,
  Steps,
  Step,
  Image as VanImage,
  ImagePreview
} from 'vant'
import { mapOperation } from '@/utils/mapOperation'
import { toNumber } from '@/utils/wnumb_own'
import {
  getOrder,
  getOrderResourceCount,
  getProductQuantity,
  getCompanyCityCode
} from '@/api/order'
import { getStationFlow } from '@/api/dw'
import { getOrderPublishInfoPage, getorderprogresslist } from '@/api/msp'

export default {
  mixins: [mapOperation], // 混入地图操作的方法
  components: {
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  data () {
    return {
      chooseCity: '',
      spinShow: false,
      svgHtml: '',
      pageType: 2, // 用于JS文件中，1标识线路开通历程，2标识线路选中

      orderCode: this.$route.params.id,
      orderBean: {}, // 订单实体
      stationList: [],

      beginPlay: false, // 播放投放情况
      playIndex: -1, // 播放序列
      chooseSchedule: {
        startDate: '',
        endDate: ''
      },

      showSchedules: false,
      defalutChooseSchedule: 0,
      scheduleColumns: [],

      showPlayContent: false,
      stationInfoData: {}, // 订单内的站点详情

      showPerformance: false, // 是否展示履约进程
      performance: [], // 履约进程
      performanceActive: 2
    }
  },
  mounted () {
    this.initPageData()
    // 设置中间区域地图高度
    this.$nextTick(() => {
      document.getElementById('svgWorkPlatform').style.height =
        document.documentElement.clientHeight + 'px'
    })
  },
  methods: {
    initPageData () {
      if (this.orderCode) {
        let postData = { code: this.orderCode }

        getOrder(postData).then((res) => {
          // 获取订单所在的城市CODE
          getCompanyCityCode({ companyId: res.publisherId }).then((city) => {
            this.chooseCity = city
            this.initMap(null, 5)
          })

          this.orderBean = res
          this.chooseSchedule = res.purchasedScheduleList[0]
          this.loadPerformanceInfo()
          this.defalutChooseSchedule = 0
          this.scheduleColumns = res.purchasedScheduleList.map(
            (x) => x.startDate + ' - ' + x.endDate
          )
        })
      }
    },
    loadOrderStationsData () {
      let postData = {
        code: this.orderCode,
        schedules: JSON.stringify([this.chooseSchedule])
      }

      getOrderResourceCount(postData).then((res) => {
        this.stationList = res
        this.loadResourceStations(res, res[0].stationId.toString(), false)
      })
    },
    formatNumber (num) {
      return toNumber(num)
    },
    handleClickStation (stationId) {
      this.beginPlay = false
      this.showPlayContent = true
      this.showPerformance = false
      this.playIndex = this.stationList.findIndex(
        (x) => x.stationId === parseInt(stationId)
      )

      this.loadResourceStations(this.stationList, stationId)
      this.loadStationInfoData(stationId)
    },
    handlePlayOrPause () {
      this.beginPlay = !this.beginPlay
      if (this.beginPlay) {
        this.showPlayContent = true
        if (this.playIndex >= this.stationList.length - 1) {
          this.playIndex = -1
        }

        this.autoReplayTime()
      }
    },
    autoReplayTime () {
      if (this.playIndex >= this.stationList.length - 1) {
        this.beginPlay = false
        return
      }

      this.playIndex += 1
      this.loadStationInfoData(this.stationList[this.playIndex].stationId)
      this.loadResourceStations(
        this.stationList,
        this.stationList[this.playIndex].stationId.toString()
      )
      setTimeout(() => {
        if (this.beginPlay) {
          this.autoReplayTime()
        }
      }, 2000)
    },
    handleChooseSchedule (val, index) {
      this.showSchedules = false
      this.chooseSchedule = this.orderBean.purchasedScheduleList[index]
      this.loadOrderStationsData()
      this.loadPerformanceInfo()
    },
    loadStationInfoData (stationId) {
      let getDataEvent = []
      let productQuantity = null
      let stationFlow = -1
      let demandList = []
      // 获取当前站点上刊数据
      let postData = {
        code: this.orderCode,
        stationId: stationId,
        schedules: JSON.stringify([this.chooseSchedule])
      }
      getDataEvent.push(
        getProductQuantity(postData).then((res) => {
          productQuantity = res
        })
      )

      // 获取站点客流
      getDataEvent.push(
        getStationFlow({ stationId: stationId }).then((res) => {
          stationFlow = res
        })
      )

      // 获取上刊反馈
      let postData2 = {
        endDate: this.chooseSchedule.endDate,
        orderId: this.orderBean.id,
        pageNumber: 1,
        pageSize: 6,
        startDate: this.chooseSchedule.startDate,
        stationId: stationId
      }
      getDataEvent.push(
        getOrderPublishInfoPage(postData2).then((res) => {
          res.list.forEach((element) => {
            element.attachVOList.forEach((item) => {
              demandList.push(item.fileKey)
            })
          })
        })
      )

      Promise.all(getDataEvent).then(() => {
        this.stationInfoData = {
          productQuantity: productQuantity,
          stationFlow: stationFlow,
          demandList: demandList
        }
      })
    },
    handleCloseTitle () {
      this.showPlayContent = false
    },
    handleImgStations (index) {
      this.beginPlay = false
      ImagePreview({
        images: this.stationInfoData.demandList,
        startPosition: index,
        closeable: true
      })
    },
    showPerformanceModal () {
      this.showPerformance = true
      this.showPlayContent = false
    },
    // 获取履约进程信息
    loadPerformanceInfo () {
      let postData = {
        orderId: this.orderBean.id,
        endDate: this.chooseSchedule.endDate,
        startDate: this.chooseSchedule.startDate
      }
      getorderprogresslist(postData).then((res) => {
        if (res.length) {
          this.performance = res[0]
          try {
            this.performance.taskProgressTypeList.forEach((item, index) => {
              if (!item.finishDate) {
                this.performanceActive = index
                throw new Error('EndForEach')
              }
            })
          } catch (e) {
            if (e.message !== 'EndForEach') throw e
          };
        } else {
          this.performance = {}
        }
      })
    }
  },
  watch: {
    spinShow (val) {
      if (val) {
        Toast.loading({
          message: '地图加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        })
      } else {
        Toast.clear()
        // 地图载入完毕，开始执行标注信息
        this.loadOrderStationsData()
      }
    }
  }
}
</script>
